import {Component, ElementRef, HostListener, OnInit} from '@angular/core';

@Component({
  selector: 'app-theme-triangle',
  templateUrl: './theme-triangle.component.html',
  styleUrls: ['./theme-triangle.component.scss']
})
export class ThemeTriangleComponent{

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/theme-triangle/theme-triangle.component.ts